import {useNotification} from "@kyvg/vue3-notification";

const {notify} = useNotification();

export const showNotify = (type: string, message: string) => {
    notify({
        text: message,
        type: type.toLowerCase()
    });
};
export const showSuccessNotify = (message: string) => {
    notify({
        text: message,
        type: 'success'
    });
};



export const showErrorNotify = (message: any) => {
    if (typeof message === 'string') {
        notify({
            text: message,
            type: 'error'
        });
    } else {
        if (message.status == 200) {
            showSuccessNotify("Успешно выполнено");
        } else if (message.status == 500) {
            showErrorNotify(message.response.data);
        }
    }
};

export const showInfoNotify = (message: string) => {
    notify({
        text: message,
        type: 'info'
    });
};
